import { useState, useEffect } from "react";
import { Link } from "./ui/link";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import Logo from "./ui/logo";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlHeader = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", controlHeader);

    return () => {
      window.removeEventListener("scroll", controlHeader);
    };
  }, [lastScrollY]);

  return (
    <>
      <header
        className={`py-4 px-6 border-b fixed top-0 left-0 right-0 bg-background z-50 transition-transform duration-300 ${
          isVisible ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="container mx-auto flex justify-between items-center">
          <Link
            href="/"
            className="flex items-center space-x-2 text-2xl font-bold"
          >
            <Logo className="size-8 hover:animate-logo-spin transition-all duration-300" />
            <span>PentAGI</span>
          </Link>

          <button
            className="lg:hidden z-50 p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <nav className="hidden lg:block">
            <ul className="flex space-x-4">
              <li>
                <Link href="#features">Features</Link>
              </li>
              <li>
                <Link href="#how-it-works">How it Works</Link>
              </li>
              <li>
                <Link href="#providers">Providers</Link>
              </li>
              <li>
                <Link href="#observability">Observability</Link>
              </li>
              <li>
                <Link href="#github">GitHub</Link>
              </li>
            </ul>
          </nav>

          <Button className="hidden lg:inline-flex" asChild>
            <Link href="/get-started">Get Started</Link>
          </Button>
        </div>
      </header>

      {isMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-background/95 backdrop-blur-sm z-40">
          <div className="h-screen flex items-center justify-center">
            <nav className="w-full">
              <ul className="flex flex-col items-center space-y-8 text-center text-lg">
                <li>
                  <Link href="#features" onClick={() => setIsMenuOpen(false)}>
                    Features
                  </Link>
                </li>
                <li>
                  <Link
                    href="#how-it-works"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    How it Works
                  </Link>
                </li>
                <li>
                  <Link href="#providers" onClick={() => setIsMenuOpen(false)}>
                    Providers
                  </Link>
                </li>
                <li>
                  <Link
                    href="#observability"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Observability
                  </Link>
                </li>
                <li>
                  <Link href="#github" onClick={() => setIsMenuOpen(false)}>
                    GitHub
                  </Link>
                </li>
                <li>
                  <Link
                    href="/get-started"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Get Started
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}
